import React, { useEffect } from "react";
import { AiOutlineClose } from "react-icons/ai";
import SermonPlanForm from "./SermonPlanForm";

const SermonPlanModal = ({ church, isOpen, onClose, onSuccess, typeofentity }) => {
  // Lock scroll when modal is open
  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = isOpen ? "hidden" : prev;
    return () => (document.body.style.overflow = prev);
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[200] flex justify-end items-center">
      {/* Backdrop */}
      <div
        onClick={onClose}
        className={`absolute inset-0 bg-black/50 backdrop-blur-sm transition-opacity duration-300 ${
          isOpen ? "opacity-100" : "opacity-0"
        }`}
      />

      {/* Modal Panel */}
      <div
        onClick={(e) => e.stopPropagation()}
        className={`relative bg-[#111] text-white shadow-2xl transition-all duration-500 rounded-md overflow-y-auto ${
          isOpen ? "translate-x-0 opacity-100" : "translate-x-full opacity-0"
        }`}
        style={{ width: "85%", height: "90%" }}
      >
        {/* Header */}
        <div className="flex justify-between items-center p-4 border-b border-gray-700">
          <h2 className="text-lg font-semibold">Create Sermon Plan from YouTube</h2>
          <button
            className="p-1"
            onClick={onClose}
          >
            <AiOutlineClose className="text-2xl" />
          </button>
        </div>

        {/* Modal Content */}
        <SermonPlanForm
          church={church}
          typeofentity={typeofentity}
          onClose={onClose}
          onSuccess={onSuccess}
        />
      </div>
    </div>
  );
};

export default SermonPlanModal;
